import type { AnswerView } from "@nl2sparql/core";

type TableAnswer = Extract<AnswerView, { kind: "table" }>;

export function ResultsTable({ answer }: { answer: TableAnswer }) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse text-sm">
        <thead>
          <tr>
            {answer.columns.map((col) => (
              <th
                key={col}
                className="border-b px-3 py-2 text-left font-mono text-xs font-semibold"
                style={{ borderColor: "var(--nl2s-border)", color: "var(--nl2s-text-muted)" }}
              >
                ?{col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {answer.rows.map((row, i) => (
            <tr key={i}>
              {row.map((cell, j) => (
                <td
                  key={j}
                  className="border-b px-3 py-2 align-top"
                  style={{ borderColor: "var(--nl2s-border)", color: "var(--nl2s-text)" }}
                >
                  {cell.iri ? (
                    <a
                      href={cell.iri}
                      target="_blank"
                      rel="noreferrer"
                      style={{ color: "var(--nl2s-accent)" }}
                    >
                      {cell.display || cell.iri}
                    </a>
                  ) : (
                    cell.display || <span style={{ color: "var(--nl2s-text-muted)" }}>—</span>
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
